import { render } from "./VisitorNameColumn.vue?vue&type=template&id=4dc8a20f"
import script from "./VisitorNameColumn.vue?vue&type=script&lang=js"
export * from "./VisitorNameColumn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__